import cookie from "js-cookie";

class CookieUtils {
  static setCookie = (key, value) => {
    const expDate = 4000;
    if (process.browser) {
      cookie.set(key, value, { expires: expDate });
    }
  };

  getCookie(key, req = {}) {
    return process.browser
      ? this.getCookieFromBrowser(key)
      : this.getCookieFromServer(key, req);
  }

  static removeCookie = (key) => {
    if (process.browser) {
      cookie.remove(key);
    }
  };

  getCookieFromBrowser(key) {
    return cookie.get(key);
  }

  getCookieFromServer(key, req) {
    if (!req.headers) return;
    const { cookie } = req.headers;

    if (!cookie) return undefined;

    const rawCookie = cookie
      .split(";")
      .find((cookie) => cookie.trim().startsWith(`${key}=`));
    if (!rawCookie) return undefined;

    return rawCookie.split("=")[1];
  }
}

export default CookieUtils;

// export const setCookie = (key, value) => {
//   if (process.browser) {
//     cookie.set(key, value);
//   }
// };

// export const removeCookie = (key) => {
//   if (process.browser) {
//     cookie.remove(key);
//   }
// };

// export const getCookie = (key, req) => {
//   return process.browser
//     ? getCookieFromBrowser(key)
//     : getCookieFromServer(key, req);
// };

// const getCookieFromBrowser = (key) => {
//   return cookie.get(key);
// };

// const getCookieFromServer = (key, req) => {
//   const { cookie } = req.headers;

//   if (!cookie) return undefined;

//   const rawCookie = cookie
//     .split(";")
//     .find((cookie) => cookie.trim().startsWith(`${key}=`));
//   if (!rawCookie) return undefined;

//   return rawCookie.split("=")[1];
// };
